const INIT_STATE = { data: [], error: null };
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case "GET_NOTIFICATIONS_SUCCESS":
      return {
        ...state,
        data: action.payload.data,
        error: null,
      };
    case "GET_NOTIFICATIONS_ERROR":
      return { ...state, data: [], error: action.payload };
    default:
      return state;
  }
};
